import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { colors } from "utils";

export const ClassRenameModal = ({ isOpen, onClose, selectedClass, onRename }) => {
  const [className, setClassName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedClass) {
      setClassName(selectedClass.name);
    }
  }, [selectedClass, isOpen]);

  const handleSave = async () => {
    if (!className.trim() || className.trim() === selectedClass?.name) {
      onClose();
      return;
    }
    setIsLoading(true);
    try {
      await onRename(selectedClass.id, className.trim());
      onClose();
    } catch {
      // Error handling is done in parent component
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
  };

  const hasChanges = className.trim() && className.trim() !== selectedClass?.name;

  return (
    <Modal show={isOpen} onHide={onClose} centered size="sm">
      <Modal.Header closeButton style={{ border: "none", paddingBottom: 0 }}>
        <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>
          Rename Class
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "16px 24px" }}>
        {isLoading && (
          <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999
          }}>
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
          </div>
        )}
        <Form.Group style={{ opacity: isLoading ? 0.5 : 1 }}>
          <Form.Control
            type="text"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter class name"
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer style={{ border: "none", padding: "0 24px 24px" }}>
        <Button
          variant="secondary"
          onClick={onClose}
          style={{
            backgroundColor: colors.neutral300,
            border: "none",
            padding: "10px 20px"
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!hasChanges || isLoading}
          style={{
            backgroundColor: hasChanges ? colors.nightlyWoods500 : colors.neutral300,
            border: "none",
            padding: "10px 20px"
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
